export default [
  {
    path: '/sale-popup',
    component: () => import('./views/Index'),
    name: 'sale-popup',
    redirect: { name: 'sale-popup-list' },
    children: [
      {
        path: '',
        name: 'sale-popup-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
